import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIsAdmin } from './useIsAdmin';

interface userWrapperProps {
    children: React.ReactNode;
}

export const UserWrapper: React.FC<userWrapperProps> = ({ children }) => {
    const navigate = useNavigate();
    const [isAdmin, isLoaded] = useIsAdmin();

    useEffect(() => {
        if ((isLoaded && isAdmin === null) || isAdmin) {
            navigate('/');
        }
    });

    if (isAdmin || isAdmin === null) {
        return <></>;
    }

    return <>{children}</>;
};
